import { useEffect, useState } from "react";
import ImageTable2 from "./ImageTable2";
import ReportSelector2 from "./ReportSelector2";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const KYCReports = () => {
  const [data, setData] = useState([]);
  const handleShowReports = async (branchObj, unitObj, empObj) => {
    const response = await fetch(
      `${API_URL}/facility/get-verification/1/${empObj.EmpCode}/aadhaarCardVerification`
    ).then((res) => res.json());
    if (response.success) {
      setData(response.data);
    } else {
      alert("Error");
    }
  };
  return (
    <>
      <ReportSelector2 handleShowReports={handleShowReports} />
      <ImageTable2 data={data || []} />
    </>
  );
};
export default KYCReports;
